import React from 'react';
import { PageContent } from 'common/styles/page';
import LandingPage from 'common/layouts/AuthLayout/LandingPage';

const NewOrganization = () => (
  <PageContent>
    <LandingPage
      title="Welcome to nuLogic!"
      subtitle="Now that your organization is created, use the admin tools to select a survey structure and configure categories!"
    />
  </PageContent>
);

export default NewOrganization;
